
import jQuery from 'jquery';
const $: JQueryStatic = jQuery;

/**
 * @brief Go to a specific page via HTTP Post
 */
export function post(uri: string) {
    // https://stackoverflow.com/a/5533477
    let form = $(`<form method="POST" action="${uri}"></form>`);
    form.appendTo(document.body);
    form.submit();
}

/**
 * @brief Log the user out
 */
export function logout() {
    post("/Identity/Account/Logout");
}

export default logout;
